import { createContext, useContext } from "react";

import type {
  AdditionalServiceData,
  FlightOffer,
  MappedFlightOffer,
  ServicesSelection,
} from "@/features/flights/types/types";
import type { FlightSearchType } from "@/types/types";

type FlightPayload = (FlightOffer & ServicesSelection) | null;

export interface FlightSelectionPayloadContextValue {
  selectedOfferIndex: string | null;
  selectedDepartureFlightId: string | null;
  selectedReturnFlightId: string | null;
  selectedFlightPayload: FlightPayload;
  selectedFlightSearchSource: FlightSearchType | null;
  handleDepartureFlightSelection: (
    offer: MappedFlightOffer,
    flightId: string,
    queryType: FlightSearchType | null,
  ) => void;
  handleReturnFlightSelection: (
    offer: MappedFlightOffer,
    flightId: string,
  ) => void;
  clearFlightSelection: () => void;
  getTravellerServices: (travellerId: string) => AdditionalServiceData[];
  setTravellerServices: (
    travellerId: string,
    service: AdditionalServiceData[],
  ) => void;
  removeTravellerServices: (travellerId: string) => void;
  promoCode: string | null;
  setPromoCode: (code: string | null) => void;
}

export const FlightSelectionPayloadContext =
  createContext<FlightSelectionPayloadContextValue | null>(null);

export const useFlightSelectionPayloadContext = () => {
  const context = useContext(FlightSelectionPayloadContext);
  if (!context) {
    throw new Error(
      "useFlightSelectionPayloadContext must be used within a FlightSelectionPayloadContextProvider",
    );
  }
  return context;
};
